import { useHead } from '@vueuse/head'

const SITE_URL = 'https://invi8.net'
const SITE_NAME = 'Invi8'
const DEFAULT_IMAGE = `${SITE_URL}/assets/logo.png`

const normalizePath = (path = '/') => {
  const cleanPath = String(path || '/').split('?')[0].split('#')[0]
  if (cleanPath === '/') return '/'
  return `/${cleanPath.replace(/^\/+|\/+$/g, '')}`
}

const absoluteUrl = (path = '/') => {
  const normalizedPath = normalizePath(path)
  return `${SITE_URL}${normalizedPath === '/' ? '/' : normalizedPath}`
}

export function useSeoMeta({
  title,
  description,
  path = '/',
  image = DEFAULT_IMAGE,
  type = 'website',
  robots = 'index, follow'
}) {
  const canonical = absoluteUrl(path)
  const fullTitle = title.includes(SITE_NAME) ? title : `${title} | ${SITE_NAME}`

  useHead({
    title: fullTitle,
    link: [
      { rel: 'canonical', href: canonical }
    ],
    meta: [
      { name: 'description', content: description },
      { name: 'robots', content: robots },
      { property: 'og:site_name', content: SITE_NAME },
      { property: 'og:type', content: type },
      { property: 'og:title', content: fullTitle },
      { property: 'og:description', content: description },
      { property: 'og:url', content: canonical },
      { property: 'og:image', content: image },
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:title', content: fullTitle },
      { name: 'twitter:description', content: description },
      { name: 'twitter:image', content: image }
    ]
  })
}
